import React from 'react'

const NotFound = () => {
    return (
        <div>
            <h1>Page non trouvée</h1>
            <p className="lead">Cette page n'existe pas...</p>
        </div>
    )
}

export default NotFound
